<template>
  <Collapse
    :expand="false"
    :title="$t('settings.regionConfig.moduleTitle.itq_tender')"
  >
    <div
      slot="content"
      class="tnc-collapse__content"
    >
      <a-row
        v-for="(item, index) in parsedI18nData"
        :key="index"
        :gutter="[10, 30]"
      >
        <a-col
          :span="7"
        >
          <label>{{ item.label }}</label>
        </a-col>
        <a-col
          :span="17"
        >
          <HKLTextareaVue
            v-if="isEditing"
            class="textarea__box"
            :value="item[`${currentLanguage}`]"
            @onChange="(val) => onChangeVal(val, index, currentLanguage)"
          />
          <div
            v-else
            class="tnc__item-value"
          >
            {{ item[`${currentLanguage}`] }}
          </div>
        </a-col>
      </a-row>
    </div>
  </collapse>
</template>

<script>
import Collapse from '@/controls/Collapse.vue'
import HKLTextareaVue from '@/controls/Input/HKLTextarea.vue'
import { useStoreGetters } from '@/store'
import { langs } from '@/utils/i18n'
import { inject } from 'vue-demi'
import { I18N_CATEGORIES, TNC_EDITING_PROVIDE } from './consts'
import { useParsedCategoryI18nResource } from './hook'

export default {
  components: {
    HKLTextareaVue,
    Collapse,
  },
  setup () {
    const i18nCategory = I18N_CATEGORIES.itq_tender
    const isEditing = inject(TNC_EDITING_PROVIDE)

    const storeLanguage = useStoreGetters('language', ['currentLanguage'])
    const i18nResource = useParsedCategoryI18nResource(i18nCategory)
    return {
      langs,
      isEditing,
      currentLanguage: storeLanguage.currentLanguage,
      ...i18nResource,
    }
  },
}
</script>

<style lang="scss" scoped>
@import './tnc.scss'
</style>
